import { BsXCircleFill } from 'react-icons/bs'
import styled from 'styled-components/macro'

export const FilterChipContainer = styled.span<{
  isExclusive?: boolean
}>`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #087443;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  border-radius: 4px;

  border: 1px solid rgba(71, 84, 103, 0);
  background: #e5ece7;
  height: 40px;

  ${({ isExclusive }) =>
    isExclusive &&
    `
      background-color: rgba(228, 76, 76, 0.10);
      color: #E44C4C;
      `}

  @media (max-width: 768px) {
    height: 24px;
    font-size: 12px;
    line-height: 24px;
  }
`

export const FilterChipCloseButton = styled(BsXCircleFill)<{
  isExclusive?: boolean
}>`
  color: ${(props) => (props.isExclusive ? '#E44C4C' : '#087443')};
  width: 13px;
  height: 13px;
  cursor: pointer;
  flex-shrink: 0;
`
